import styled from "styled-components";
import { theme } from "../../styles/theme";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: ${theme.colors.background.overlay};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.md};
  z-index: 1200;
`;

const ModalContainer = styled.div`
  width: 100%;
  max-width: 440px;
  background-color: ${theme.colors.background.secondary};
  border-radius: ${theme.borderRadius.md};
  border: ${theme.borders.base};
  overflow: hidden;
  animation: rise ${theme.transitions.normal};

  @keyframes rise {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const ModalBody = styled.div`
  padding: ${theme.spacing.lg};
  max-height: 70vh;
  overflow-y: auto;
`;

export function Modal({ isOpen, onClose, title, children }) {
  if (!isOpen) return null;

  let mouseDownTarget = null;

  const handleMouseDown = (event) => {
    // Track where the mouse down event occurred
    mouseDownTarget = event.target;
  };

  const handleMouseUp = (event) => {
    // Only close if both mousedown and mouseup happened on the overlay
    // This prevents closing when dragging/selecting text
    if (
      mouseDownTarget === event.currentTarget &&
      event.target === event.currentTarget
    ) {
      onClose();
    }
    mouseDownTarget = null;
  };

  return (
    <Overlay onMouseDown={handleMouseDown} onMouseUp={handleMouseUp}>
      <ModalContainer role="dialog" aria-modal="true">
        <ModalBody>{children}</ModalBody>
      </ModalContainer>
    </Overlay>
  );
}


